import React from "react";
import { Box, Theme, useMediaQuery } from "@mui/material";
import { MandatorConditional } from "@helpers";
import { useFundamentalsContext } from "../FundamentalsContext";
import { AddMenu } from "./FundamentalsCard/AddMenu";

type Props = {
  activeTab?: string;
  fundamentalsTabKey?: string;
  inTabsBar?: boolean;
  fullWidth?: boolean;
};

export const FundamentalsActions = ({
  activeTab,
  fundamentalsTabKey = "fundamentals",
  inTabsBar = true,
  fullWidth,
}: Props) => {
  const { menuItems, selectedMetrics, toggleMetric, isInvestmentFund } =
    useFundamentalsContext();
  const isSm = useMediaQuery((theme: Theme) => theme.breakpoints.down("sm"));

  const shouldRenderInTabsBar = inTabsBar && !isSm;
  const shouldRenderInContent = !inTabsBar && isSm;

  const isFundamentalsTab = !activeTab || activeTab === fundamentalsTabKey;
  const hasMenuItems = menuItems && menuItems.length > 0;

  if (
    isInvestmentFund ||
    !hasMenuItems ||
    !isFundamentalsTab ||
    (!shouldRenderInTabsBar && !shouldRenderInContent)
  ) {
    return null;
  }

  const node = (
    <MandatorConditional hideFor={["kpmg-germany"]}>
      <AddMenu
        items={menuItems}
        onSelect={toggleMetric}
        selected={selectedMetrics.map(({ mainMetricKey }) => mainMetricKey)}
        variant="outlined"
        fullWidth={Boolean(fullWidth) || shouldRenderInContent}
      />
    </MandatorConditional>
  );

  return shouldRenderInTabsBar ? (
    <Box display="flex" alignItems="center" mt={!shouldRenderInTabsBar ? 5 : 0}>
      {node}
    </Box>
  ) : (
    <Box mt={5}>{node}</Box>
  );
};
